import React from "react";
import {Card, Stack, Typography, Box} from "@mui/material";

export default function OneInfoCard({ item }) {

    return (
        <Card sx={{transition: 'all 0.3s ease', px:2, py:3, height: '100%', boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)', '&:hover': {boxShadow: 3, transform: 'translateY(-2px)'}}}>
            <Stack direction='row' spacing={2}>
                {item.icon}
                <Box>
                    <Typography variant="body1" sx={{color: "black", fontSize:16, marginTop:1, fontWeight:600}}>{item.label}</Typography>
                </Box>
            </Stack>
            
            {item.data}
        </Card>
    )
}